import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { routePathName } from '@app/app.models';
import { CompaniesResolverService } from '@services/company';
import { AuthGuardService as AuthGuard } from '@services/router-guards/auth-guard.service';
import { ManagerComponent } from './manager.component';
import { AccountSettingsComponent, ApiDocumentationComponent } from './modules';

const routes: Routes = [
	{
		path: '',
		component: ManagerComponent,
		children: [
			{
				path: routePathName.account,
				component: AccountSettingsComponent,
				resolve: {
					companies: CompaniesResolverService
				},
				canActivate: [AuthGuard]
			},
			{
				path: routePathName.users,
				loadChildren: () => import('./modules/users').then((m) => m.UsersModule),
				resolve: {
					companies: CompaniesResolverService
				},
				canActivate: [AuthGuard]
			},
			{
				path: routePathName.registrations,
				loadChildren: () => import('./modules/registrations').then((m) => m.RegistrationsModule),
				canActivate: [AuthGuard]
			},
			{
				path: routePathName.apiDocumentation,
				component: ApiDocumentationComponent,
				resolve: {
					companies: CompaniesResolverService
				},
				canActivate: [AuthGuard],
				children: [
					{
						path: ':clusterId',
						component: ApiDocumentationComponent,
						children: [{ path: '**', component: ApiDocumentationComponent }]
					}
				]
			},
			{
				path: routePathName.apps,
				loadChildren: () => import('./modules/company').then((m) => m.CompanyModule),
				resolve: {
					companies: CompaniesResolverService
				},
				canActivate: [AuthGuard]
			},
			{
				path: '',
				redirectTo: routePathName.apps,
				pathMatch: 'full'
			}
		]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class ManagerRoutingModule {}
